export default {
	termsAndConditions: {
		lastUpdate: 'Utolsó frissítés: 2024. június 10',
		content: `
		<p>Az alábbiakban található feltételek fontosak, mert:</p>
		<ul>
			<li>A {siteName} webhelyen rögzítik törvényes jogaikat.</li>
			<li>Magyarázza el, milyen jogokat biztosít nekünk a {siteName} használata során.</li>
			<li>
				Leírják azokat a szabályokat, amelyeket mindenkinek be kell tartania a {siteName} használata során.
			</li>
		</ul>
		<p>
			Kérjük, figyelmesen olvassa el ezeket a Feltételeket, valamint a {privacyPolicyLink} és egyéb linkeket
			a jelen Feltételekben említett dokumentumokat.
		</p>
		<p>Kezdjük...</p>
		<h3>1. A {siteNameUpper} BEVEZETÉSE ÉS ADATAI.</h3>
		<p>
			A {websiteLink} webhely (a továbbiakban: "Webhely") a cég tulajdona
			{siteName} S.L (a továbbiakban: "{siteName}"), egy vállalat
			a spanyol jogszabályokkal összhangban, címe: Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), a CIF-szám birtokosa
			B-56.768.260, és be van jegyezve a Barcelona Mercantile Registry of the Volume
			49065, Folio 0033, B-606324 lap, 1. regisztráció.
		</p>
		<p>
			A {siteName} az Ön rendelkezésére bocsátja a webhelyet, hogy Ön elérhesse
			ismerjen meg minket jobban, ismerje meg szolgáltatásainkat, és ha kívánja, lépjen kapcsolatba velünk
			és adott esetben szerződést köt velünk.
		</p>
		<h3>2. A FELHASZNÁLÁSI FELTÉTELEK CÉLJA ÉS ALKALMAZÁSI KÖRE</h3>
		<p>
			Ezek a használati feltételek a {privacyPolicyLink} és a
			{cookiesPolicyLink}, a weboldal használatát szabályozó jogi keret
			{weboldal link}. Ezeket a felhasználási feltételeket a weboldalon érheti el
			angolul, hogy bármikor tájékozódhasson, archiválhasson vagy kinyomtathasson, és
			amikor csak akarod.
		</p>
		<p>
			A(z) {siteName} által végzett kezeléssel kapcsolatos kérdések megválaszolásához.
			személyes adatairól, kérjük, keresse fel a {privacyPolicyLink} és a {cookiesPolicyLink} oldalunkat.
			Mindkét szabályzat angol nyelven is elérhető lesz az Ön számára, így Ön is megteheti
			bármikor megtekintheti, archiválhatja vagy kinyomtathatja őket.<br />
			A {siteName} harmadik féltől származó cookie-kat használ a webhelyen. Többet megtudni
			az interneten {websiteLink} használt cookie-k típusáról, céljáról és módjáról
			böngészőjének konfigurálásához arra az esetre, ha nem szeretné, hogy ezeket a sütiket használjuk,
			kérjük, keresse fel a {cookiesPolicyLink} oldalunkat.
		</p>
		<p>
			Mind a jelen használati feltételek, mind a {privacyPolicyLink} és a 
			A(z) {cookiesPolicyLink} a jelenlegi rendelkezései szerint készült
			hatályos rendeletei, többek között a szolgáltatásokról szóló 34/2002
			Információs társadalom és elektronikus kereskedelem, valamint az (EU) 2016/679 rendelet
			az Európai Parlament és a Tanács 2016. április 27-i határozata a
			a természetes személyek védelme a személyes adatok feldolgozása tekintetében
			adatok és ezen adatok szabad áramlása, és amellyel a 95/46/EK irányelv
			hatályát veszti.
		</p>
		<h3>3. ELÉRÉS A WEBOLDALHOZ ÉS ELFOGADÁS</h3>
		<p>
			A Weboldalhoz való hozzáférés ingyenes, kivéve a költséggel kapcsolatos részt
			kapcsolat az internet által biztosított távközlési hálózaton keresztül
			hozzáférési szolgáltató, amellyel szerződést kötött. A Weboldalon szabadon böngészhet
			és annyiszor érheti el, ahányszor csak akarja. A Weboldal eléréséhez és navigálásához,
			nem kell regisztrálnia, kivéve, ha szolgáltatást szeretne bérelni.
		</p>
		<p>
			A weboldal használata megadja a weboldal felhasználói állapotát
			(a továbbiakban: „Felhasználó”), és az Ön teljes és fenntartás nélküli elfogadását jelenti
			ezek a használati feltételek, valamint a {privacyPolicyLink} és a {cookiesPolicyLink}
			a Webhelyről. Ezenkívül beleegyezik abba, hogy nem használja a Szolgáltatást illegális célokra
			célokra.
		</p>
		<p>
			A Weboldal megnyitásával és böngészésével Ön kijelenti, hogy a
			felelősséggel tartozik, hogy nagykorú, és rendelkezik a szükséges jogi feltételekkel
			a Webhely eléréséhez és használatához szükséges képességet, egyúttal kijelenti, hogy Ön teljes mértékben
			fenntartás nélkül megérti és elfogadja ezeket a használati feltételeket.
		</p>
		<p>
			Másrészt tájékoztatjuk, hogy jogi okokból archiváljuk a
			elektronikus dokumentumok, amelyekben a vásárlások formalizálódnak. Hozzáférhetsz
			ezeket a dokumentumokat bármikor kérheti: {supportLink}.
		</p>
		<h3>4. A WEBOLDAL HASZNÁLATÁNAK FELTÉTELEI</h3>
		<p>
			A Felhasználó vállalja, hogy a Weboldalt a jelen használati feltételeknek megfelelően használja,
			hatályos jogszabályok és jóhiszeműség. Így a Felhasználó válaszol a {siteName} címre.
			 és bármely harmadik fél előtt az ebből eredő károkért és veszteségekért
			az e feltételekkel, a jogszabályokkal és a jóhiszeműséggel ellentétes felhasználást
			a Weboldal Felhasználója által.
		</p>
		<h3>5. A SZOLGÁLTATÁS LEÍRÁSA</h3>
		<p>
			A Szolgáltatáson keresztül a {siteName} lehetővé teszi a szolgáltatásra való előfizetést
			képszerkesztést végezni.
		</p>
		<p>
			Az a nyelv, amelyen a {siteName} és a vevő között létrejött szerződés
			a származási országé lesz.<br />
			Az online szolgáltatásban a vásárlás folyamata a következő:
		</p>
		<ol>
			<li>Felhasználónévvel és jelszóval kell regisztrálnia a webhelyen.</li>
			<li>
				A regisztrációkor a felhasználónak ki kell választania egy fizetési konstrukciót
				az Árak részben találhatók, és attól függően kapnak kreditet
				kiválasztott terv. Minden kredit egy kép szerkesztését teszi lehetővé.
			</li>
			<li>
				A szolgáltatás megvásárlása után a felhasználó adminisztrációt kap
				panel, ahol megtalálják:
				<ul>
					<li>
						Egy szakasz az összes feldolgozott kép listájával
						annyiszor szerkesztheti, ahányszor csak akarja, és letöltheti saját webhelyére
						eszköz.
					</li>
					<li>
						A tervek és kifizetések szakasza a számlák megtekintéséhez és a törléshez
						Feliratkozás.
					</li>
					<li>A Saját fiók egy része, ahol módosíthatja a fiókbeállításokat.</li>
				</ul>
			</li>
		</ol>
		<p>
			A szolgáltatás megvásárlását követően azt visszaigazolja
			e-mail küldése, legfeljebb 24 órán belül az Ön által megadott címre
			jelzett. Jelzi a szolgáltatást, az előfizetés lemondásának módját, annak
			összegét, a vonatkozó adókat, a fizetési módot és az alkalmazandó feltételeket és
			körülmények.
		</p>
		<h4>5.1-előfizetés</h4>
		<p>
			A szolgáltatás előfizetése a kiválasztott előfizetéstől függően változik, és az is lesz
			automatikusan meghosszabbodik ugyanennyi időre a megszűnéséig.
			Hacsak nem mondja le előfizetését, felhatalmaz minket a letöltésre
			a megfelelő éves előfizetési díjat a fizetési módban.
		</p>
		<p>
			A Szolgáltatásra való előfizetését bármikor lemondhatja, és ezt meg is teszi
			továbbra is hozzáférhet az éves számlázási időszak végéig. Nak nek
			a törvény által megengedett mértékben a befizetések vissza nem térítendők, és nem biztosítunk
			visszatérítések vagy jóváírások a részleges éves előfizetési időszakokra.
		</p>
		<h3>6. ÁR ÉS ADÓK</h3>
		<p>
			A {siteName} oldalon kínált termékek árai euróban vannak feltüntetve
			(€) vagy annak az országnak a pénzneme, ahol a vásárlás történik, az Érték
			A vásárlás időpontjában hatályos általános forgalmi adó (áfa) az árra kerül felszámításra
			Termékek.
		</p>
		<p>
			Mindenesetre a művelet mentes vagy nem áfa-köteles attól függően
			az Ön lakóhelye szerinti országot vagy azt az állapotot, amelyben cselekszik. Emiatt,
			egyes esetekben a megrendelés végső ára módosulhat a
			az egyik látható.<br />
			Az ÁFA fizetési kötelezettség alól mentes alanyok vásárlásainál ezt jelzik
			áfa-/NIF-számukat e-mailben elküldik a {supportLink} címre, nem rögzítik
			vásárlások az említett adóval.
		</p>
		<h3>7. FIZETÉSI MÓD</h3>
		<p>
			A megvásárolt szolgáltatás online fizetése történhet hitel- vagy betéti kártyával.
			Ebben az értelemben a {siteName} tájékoztatja a hitel- és bankkártya-tulajdonosokat arról
			az online áruházban a tranzakciók biztonságos fizetéssel történnek
			átjáró, SSL technológia használatával garantálja az adatátvitel biztonságát.
		</p>
		<h3>8. ELÁLLÁSI ÉS VISSZATÉRÍTÉSI JOG</h3>
		<h4>8.1. Elállási jog</h4>
		<p>
			Tekintettel az online szolgáltatásunkban forgalmazott termék típusára, digitális szoftver
			QR formátumban, az elállási jog nem érvényesíthető
			A november 16-i 1/2007 királyi törvényerejű rendelet 103. cikkének m) pontja
			az, hogy a fogyasztóvédelmi általános törvény átdolgozott szövege és
			A felhasználókat és az egyéb kiegészítő törvényeket jóváhagyták.
		</p>
		<h4>8.2. Visszatérítések</h4>
		<p>
			Függetlenül attól, hogy a felhasználó milyen konstrukciót választott, a felhasználó által fizetett összegek és a
			törvény által megengedett mértékig nem téríthető vissza.
		</p>
		<p>
			A szerződött szolgáltatás nem ruházható át vagy ruházható át más felhasználóra
			a szolgáltatás.
		</p>
		<p>
			A szerződéses szolgáltatást a felhasználó minden esetben a végéig igénybe veheti
			a szerződéses időszak.
		</p>
		<h3>9. AJÁNLATOK ÉRVÉNYESSÉGE</h3>
		<p>
			A Szolgáltatásban kínált szolgáltatások és azok árai elérhetőek lesznek
			vásárolni, amíg az ezen keresztül megjelenített szolgáltatások katalógusában vannak
			weboldal.
		</p>
		<p>
			A {siteName} minden esetben fenntartja a jogot a módosítások végrehajtására
			megfelelőnek ítéli a Szolgáltatásban, frissíteni tudja a termékeket és szolgáltatásokat
			a piactól függően.
		</p>
		<p>
			A {siteName} fenntartja a jogot az árak előzetes értesítés nélküli megváltoztatására. Mi
			Tájékoztatjuk Önt, hogy az árfrissítések ellenére a
			Szolgáltatás, hibákat tartalmazhatnak. Az esetleges hibákat azonnal kijavítjuk
			megjelennek, de nem kötelező érvényűek a Szolgáltatásra nézve.
		</p>
		<h3>10. BIZTONSÁG</h3>
		<p>
			Mint fentebb jeleztük, a teljes vásárlási eljárás, valamint az átvitel
			személyes adatainak és fizetési rendszereinek kezelése egy biztonságos oldalon történik, és
			titkosított módon az SSL protokollon keresztül.
		</p>
		<p>
			Garantáljuk a Szolgáltatás biztonságát a mindenkor érvényesnek megfelelően
			technológiai ismeretek. A {siteName} azonban nem tudja garantálni a teljességet
			a Szolgáltatás jövőbeli biztonságát. Mindenesetre megígérjük, hogy kijavítjuk és
			meg kell tenni a megfelelő korrekciós intézkedéseket az esetleges biztonság kijavításához
			megsértése a lehető leghamarabb.
		</p>
		<p>
			Ön beleegyezik abba, hogy azonnal értesítse a következőt: {siteName}, e-mailben {supportLink}
			minden olyan helyzetről, amely a felhasználó személyazonosságának megszemélyesítéséhez vezethet.
		</p>
		<h3>11. MÓDOSÍTÁSOK ÉS MINDENSÉGESSÉG</h3>
		<p>
			A Szolgáltatás feltételeit a jövőben is frissíthetjük
			mint magának a Szolgáltatásnak a jellemzői és funkciói.
		</p>
		<p>
			A feltételek változásáról értesítéssel tájékoztatjuk
			jól látható helyen a weboldalunkon és/vagy e-mailben.
		</p>
		<p>
			Ha a jelen feltételekben foglalt bármely kitételt bejelentik, teljes mértékben ill
			részleges, semmis vagy hatálytalan, csak az említett rendelkezést vagy a részt érinti
			amely semmis vagy hatástalan. A feltételek ben maradnak érvényben
			minden más, amelyre ilyen rendelkezés vonatkozik, vagy annak az érintett része
			nem kerül elhelyezésre.
		</p>
		<h3>12. A SZERZŐDÉSBŐL EREDMÉNYEZŐ IGÉNYEK ÉS KERESÉSEK</h3>
		<p>
			Amennyire lehetséges, erre a Szolgáltatásra a spanyol jog az irányadó.<br />
			A követelések polgári eljárás útján történő rendezésének egyszerűsítése érdekében ill
			csökkenteni a költségeket, nem zárjuk ki annak lehetőségét, hogy alávetjük magunkat egy
			A Kereskedelmi Kamarák Választottbíróságának méltányossági választottbírósága és
			Ipar. Ebben az értelemben és a vonatkozó szabályozás szerint
			 A {siteName} európai online vitarendezés létezéséről tájékoztat
			platform, amely megkönnyíti az ilyen viták peren kívüli rendezését
			a fogyasztók és az Internet szolgáltatás között online kötött szerződések is
			szolgáltatók. Ez a platform az alábbi weboldalon keresztül érhető el:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. SZELLEMI ÉS IPARI TULAJDONJOGOK</h3>
		<p>
			A Weboldal és annak tartalma a védelem hatálya alá tartozik
			a szellemi és/vagy ipari tulajdonra vonatkozó jelenlegi nemzeti szabályozások, mint
			valamint az ilyenekre vonatkozó nemzetközi egyezmények alkalmazásakor
			számít. {siteName} az összes tulajdonosa, vagy megfelelő licenccel rendelkezik
			Szellemi és ipari tulajdonjogok a Weboldalon és annak tartalmában.
		</p>
		<p>
			A sokszorosítás, terjesztés, nyilvános kommunikáció, átalakítás bármilyen formája,
			elérhetővé tétele és általában minden más hasznosítási cselekmény, függetlenül attól, hogy
			a Weboldal vagy annak tartalmának kereskedelmi céljaira, előzetes előzetes
			{siteName} kifejezett beleegyezése. Kifejezetten tilos törölni a
			azonosítja a(z) {siteName} adatait, mint a Szellemi és
			A Weboldal vagy annak tartalmának ipari tulajdonjogai.
		</p>
		<p>
			A {siteName} fenntart minden szellemi és ipari tulajdonjogot
			a Weboldal és annak tartalma felett, fenntartva minden jogi jog gyakorlását
			az ennek megfelelő cselekmények annak megszüntetése, megelőzése vagy üldözése érdekében
			a Weboldal vagy annak tartalmának tiltott használata. Semmilyen esetben és a sz
			körülmények között nem fér hozzá a Weboldalhoz, vagy használja azt a Felhasználó vagy harmadik személy
			a felek a(z) {siteName} általi bármilyen jellegű megbízást alkotnak vagy utalnak arra
			a Weboldalhoz vagy annak tartalmához kapcsolódó szellemi vagy ipari tulajdonjogok.
			Semmi esetre sem, ha a {siteName} nem követelte meg a
			A weboldal vagy annak illegális, vagy a jelen feltételekkel ellentétes tartalma lehet
			a(z) {siteName} hallgatólagos beleegyezéseként vagy lemondásként értendő az ilyen felhasználásokhoz
			az esetlegesen ennek megfelelő jogi lépések gyakorlásáról.
		</p>
		<h3>14. KÖTELEZETTSÉGEK ÉS GARANCIA</h3>
		<p>
			A Felhasználó köteles a Weboldalt és annak tartalmát a
			jelen használati feltételek rendelkezései, a hatályos jogszabályok és a jóhiszeműség. Bármi
			a weboldal vagy annak tartalmának jelen általános feltételekkel ellentétes használata, a
			törvény vagy jóhiszeműség kifejezetten tilos, függetlenül attól, hogy az említett felhasználás megtörtént-e
			gazdasági cél vagy sem.<br />
			A Felhasználó felelős a(z) {siteName} számára okozott károkért vagy károkért
			 vagy bármely felhasználásból közvetlenül vagy közvetve származó harmadik feleknek
			amelyet a Felhasználó a Weboldalról vagy annak tartalmáról ezekkel ellentétesen tesz
			feltételek, a törvény, az erkölcs, a közrend vagy a jóhiszeműség.
		</p>
		<p>
			Ahhoz, hogy a Webhely és annak tartalma elérhető legyen a Felhasználó számára, {siteName}
			 harmadik felek által nyújtott szolgáltatásokat igényel. Lehetséges, hogy
			annak ellenére, hogy a {siteName} igyekezett fenntartani a Webhelyet
			és a felhasználók számára hozzáférhető, elérhetősége felfüggeszthető, megszakítható ill
			törölve a(z) {siteName} webhelyen kívüli okok miatt. Ezért {siteName}
			nem garantálja a megszakítások vagy hibák hiányát a hozzáférés során
			A webhely vagy annak tartalma, sem azt, hogy azok frissüljenek vagy mindig megjelenjenek
			legújabb verziójukat. Következésképpen a {siteName} bármelyiket elutasítja
			felelősség a Felhasználót vagy harmadik feleket ért károkért
			a felfüggesztés, megszakítás, folytonosság hiánya, hálózatkimaradás következménye
			vagy a Webhely leválasztása.
		</p>
		<p>
			A {siteName} semmilyen esetben és semmilyen körülmények között nem vállal felelősséget
			a felhasználót ért károk vagy veszteségek olyan okokból, amelyek nem a(z) {siteName} webhelynek tulajdoníthatók
			 mint például, és semmi esetre sem korlátozó jellegű, természetes
			katasztrófák, vis maior vagy rendkívüli sürgősségi helyzetek, vírusok, káros
			alkatrészek, böngésző hibás működés, hálózati leállás, számítógép behatolás ill
			harmadik felek támadásai.
		</p>
		
		<h3>15. LINKEK</h3>
		<p>
			Azok a webhelyek, platformok, fórumok, chatek, blogok vagy külső közösségi hálózatok, amelyek
			A weboldalra mutató hivatkozásnak vagy hivatkozásnak egyértelműen tájékoztatnia kell arról, hogy nem rendelkezik a
			a {siteName} felhatalmazása vagy felügyelete, és az említett linkelés vagy
			a link nem von maga után, nem feltételez és nem utal semmiféle kapcsolatra a(z) {siteName} között
			és a webhelyek, platformok, fórumok, csevegések, blogok vagy külső
			közösségi hálózatok, amelyek a Webhelyre hivatkoznak.
		</p>
		<p>
			Mindenesetre minden olyan hivatkozást, amely a Weboldalra szán, irányítani kell
			közvetlenül a Honlap kezdőlapjára vagy kezdőlapjára az URL-re kattintva
			a weboldal teljes képernyőjét lefedve a kezdőlap vagy a kezdőlap oldala
			a Weboldalon, hogy a hivatkozás abszolút és teljes legyen a használata nélkül
			keretek, keretek vagy hiperhivatkozások. A {siteName} semmilyen esetben sem válaszol
			és semmilyen körülmények között a kapcsolódó tartalomra, információkra vagy adatokra
			webhely, annak tartalma vagy bármely más, a webhelyeken, platformokon található anyag,
			fórumok, csevegések, blogok vagy harmadik felek közösségi hálózatai, amelyek linket vagy linket tartalmaznak
			Weboldal.
		</p>
		<p>
			Kifejezetten tilos a Weboldalra hivatkozást vagy hivatkozást webhelyekről,
			törvényekkel, erkölcsökkel ellentétes platformok, fórumok, chatek, blogok vagy közösségi hálózatok
			és a jó szokások, különösen a pornográf, tiltott, illegális ill
			emberi jogokat sértő tartalom.
		</p>
		<p>
			Másrészt a Weboldal tartalmazhat hivatkozásokat harmadik felek webhelyeire,
			platformokon, fórumokon, csevegéseken, blogokon vagy közösségi hálózatokon. A {siteName} nem
			rendelkezik emberi és/vagy technikai eszközökkel az információ megismeréséhez vagy ellenőrzéséhez, és
			harmadik felek webhelyein megjelenő tartalmak. Ezért a {siteName} semmilyen esetben sem
			felelősséggel tartozik a hivatkozott oldalak tartalmáért és a sz
			körülmények között az említett linkek a tartalom hatékony ismeretének tekinthetők
			azon webhelyek közül, amelyekre hivatkoznak.
		</p>

		<h3>16. ADATVÉDELEM</h3>
		<p>
			A {privacyPolicyLink}-ben foglaltak szerint a {siteName} vállalja, hogy használja a Felhasználót
			adatait, tiszteletben tartja azok bizalmas kezelését, és az abban foglaltaknak megfelelően használja fel
			a kezelés célját, valamint a mentési kötelezettségének eleget tenni.
			és minden intézkedést módosítani kell a változtatás, elvesztés, kezelés vagy jogosulatlan kezelés elkerülése érdekében
			vonatkozó hatályos jogszabályok előírásainak megfelelő hozzáférést
			személyes adatok védelme.
		</p>
		<p>
			A Weboldal megfelelő biztosítékokat tartalmaz, és ipari szabványokat alkalmaz
			technológia a biztonság, integritás, teljesség, pontosság és
			az általa gyűjtött és megállapított személyes adatok védelmét
			ésszerű óvintézkedések az információk esetleges elvesztése elleni védelme érdekében, vagy
			visszaélés. Adatvédelmi és biztonsági szabályait időszakonként felülvizsgálják
			és szükség esetén javítani kell, és arra törekszik, hogy csak az engedélyezett
			személyek hozzáférhetnek a Felhasználó által megadott információkhoz.
		</p>
		<p>
			További információ a {siteName} által végzett kezelésről és kezelésről
			 adatairól, kérjük, olvassa el a {privacyPolicyLink} és a {cookiesPolicyLink} oldalunkat.
		</p>
		<h3>17. IDŐTARTAM ÉS MÓDOSÍTÁS</h3>
		<p>
			Ezek a használati feltételek mindaddig érvényben maradnak, amíg ki vannak téve
			a felhasználókat, hogy amint teljesen vagy részben módosítják vagy frissítik őket,
			ezek a feltételek érvényüket vesztik, lévén az új felhasználási feltételek
			amelyek tovább szabályozzák a Webhely használatát.
		</p>
		<p>
			A {siteName} fenntartja a jogot ezek áttekintésére, módosítására vagy frissítésére
			felhasználási feltételeket bármikor. Ezen feltételek bármilyen változása esetén
			bármilyen okból történő használatról, a {siteName} értesíti a felhasználókat a webhely kezdőlapján
			az interneten az említett körülményről, hogy megfelelően tájékozódjanak és konzultálhassanak
			a jelen használati feltételek felülvizsgálata, módosítása vagy frissítése
			az Ön elégedettsége.
		</p>
		<h3>18. ÁLTALÁNOS</h3>
		<p>
			Semmilyen esetben és semmilyen körülmények között nem járhat jogai gyakorlásának hiányában
			a {siteName} által róluk való lemondásként kell érteni.
		</p>
		<p>
			A jelen feltételekben szereplő címsorok csupán tájékoztató jellegűek, ill
			tájékoztató jellegűek, hogy az értelmezést ne befolyásolják, minősítsék vagy bővítsék
			abból.
		</p>
		<p>
			Abban az esetben, ha a jelen feltételekben foglalt bármely záradék az
			a bíróság teljesen vagy részben semmisnek, visszaélésszerűnek vagy végrehajthatatlannak nyilvánította
			vagy közigazgatási szerv, az említett nyilatkozat egyedileg érinti a záradékot
			szóban forgó nemnek tekintve és semmissé nyilvánítás nélkül, visszaélés ill
			alkalmatlanságát semmilyen körülmények között kiterjesztik a többi részre
			feltételek, amelyek fennmaradnak.
		</p>
		<p>
			A jelen használati feltételek, valamint a {privacyPolicyLink} és a {cookiesPolicyLink}
			mindenkor a jelenlegi spanyol szabályozás szabályozza.
		</p>
		<h3>19. ÜGYFÉLSZOLGÁLAT</h3>
		<p>
			Bármilyen tisztázásért, incidensért vagy panaszért forduljon hozzánk a következő címen:<br />
			E-mail: {supportLink}<br />
			Postacím: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanyolország.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Utolsó frissítés: 2024. június 10',
		content: `
			<h3>1. Felelős fél és leírás</h3>
			<h5>1.1. Felelős</h5>re
			<p>A webhely kezeléséért felelős személy az Remove Background S.L (a továbbiakban: Remove Background 
			vagy a Szolgáltatás), melynek címe Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanyolország.</p>
			<p>NIF: B56768260<br> E-mail: {supportLink}</p>

			<h5>1.2. Leírás</h5>
			<p>A Háttér eltávolítása adatvédelmi szabályzatának (a továbbiakban: "Adatvédelmi szabályzat") elfogadása szükséges feltétel 
				weboldalunk használatához és a szolgáltatás (a továbbiakban: Szolgáltatás) nyújtásához.<br>
				Ez az adatvédelmi szabályzat szabályozza az Ön személyes és nem személyes adatainak gyűjtését, kezelését és felhasználását 
				mint a Remove Background felhasználója, a fejlécben megjelenő hatálybalépési dátumtól kezdve.<br>
				Az Ön személyes adatainak feldolgozásához az Remove Background megfelel a hatályos helyi és európai jogszabályoknak, 
				valamint végrehajtási rendeletei.</p>


			<h3>2. Összegyűjtött információ</h3>
			<p>Webhelyünkhöz minden információ megadása nélkül is hozzáférhet, bár regisztráció és/ 
				vagy szerződést köt terveinkkel, meg kell adnia nekünk néhány személyes adatot. Az információ (személyes 
				vagy nem személyes) a Szolgáltatás által gyűjtött, attól függően változhat.<br>
				A Szolgáltatás által gyűjtött személyes és nem személyes adatok háromféleképpen jutnak el hozzánk: 1) melyik 
				automatikusan begyűjtjük 2) azt, amit önként ad nekünk, és 3) azt, amit harmadik felek biztosítanak.</p>

			<h5>2.1. Az automatikusan gyűjtött</h5>et
			<p>Ez az információ a következőkből áll:</p>
			<ul>
				<li>Az, amelyet az eszközén tárolt cookie-k vagy hasonló mechanizmusok révén gyűjtenek, mindig az Ön beleegyezésével vagy be 
					más jogalapoknak megfelelően. További információért tekintse meg Cookie-szabályzatunkat.</li>
				<li>Az IP cím, amelyről a kapcsolat jön, a használt eszköz típusa és jellemzői, verziója 
					az operációs rendszer, a böngésző típusa, a nyelv, a dátum, az ország, a kérés időpontja, 
					többek között a származási hely URL-címe, az URL, amelyre felkeresett, vagy a használt mobilhálózat.</li>
				<li>Szolgáltatáshasználati adatok és a használat során észlelt lehetséges hibák.</li>
				<li>Ezenkívül a Háttér eltávolítása a Google Analytics elemző szolgáltatást használja, amelyet a Google, LLC biztosít. 
					Székhelye az Egyesült Államokban található, székhelye: 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					E szolgáltatások nyújtásához cookie-kat használnak, amelyek információkat gyűjtenek, beleértve a felhasználó IP-címét, 
					amelyeket a Google továbbít, feldolgoz és tárol a www.google.com weboldalon meghatározott feltételek szerint. 
					Beleértve az említett információk esetleges továbbítását harmadik felek részére jogszabályi előírás vagy 
					amikor az említett harmadik felek a Google nevében dolgozzák fel az információkat.</li>
			</ul>
			<p>Minden esetben letilthatja a Google Analytics cookie-kat <a href="{externalLink: disableGoogleAnalyticsLink}">itt</a>.</p>

			<h5>2.2. Azt, amelyet önként ad</h5>
			<p>Ez az információ a következőkből áll:</p>
			<ul>
				<li>Minden adat kötelező.</li>
				<li>Az a név, amelyre a Háttér eltávolítása funkciónak szüksége van a regisztráció befejezéséhez az interneten: többek között vezeték- és vezetéknév, cím és e-mail-cím.</li>
				<li>Minden adat kötelező.</li>
				<li>A szolgáltatás szerződéskötésének befejezéséhez szükséges személyes adatok, például az e-mail-cím és a hitel- vagy bankkártya száma.</li>
				<li>A Szolgáltatásban kialakított kapcsolattartási vagy véleményezési csatornákon keresztül küldött üzenetek – akár személyes, akár nem – információkat tartalmazhatnak, 
					például az Ön nevét és e-mail címét.</li>
			</ul>

			<h5>2.3. A harmadik felek által biztosított</h5>
			<p>Ez az információ a következőkből áll:</p>
			<ul>
				<li>A fizetési rendszerek vagy hitelkártya-feldolgozók által biztosított érték, például a vásárlás időpontja vagy annak összege.</li>
			</ul>


			<h3>3. Jogok és célok</h3>
			<p>Tájékoztatjuk, hogy az űrlapok kitöltése önkéntes. Ha azonban nem tölti ki a kötelező mezőket 
				(általában csillaggal jelölve), a Szolgáltatás egyes funkciói nem vagy korlátozottak lesznek.<br>
				Az Ön által számunkra megadott személyes adatokat beépítjük és feldolgozzuk a háttér eltávolításával kapcsolatos kezelési tevékenységek nyilvántartásába. 
				annak érdekében, hogy az Ön kéréseit teljesíteni tudja, a kért szolgáltatást nyújtsa, és folyamatosan tájékoztassa a tevékenységgel kapcsolatos ügyekről 
				a cégről és szolgáltatásairól.<br>
				Ön bármikor gyakorolhatja a hozzáférési, helyesbítési, törlési, kezelési korlátozási jogát, 
				személyes adatainak tiltakozása és hordozhatósága e-mailben a következő címre: {supportLink} vagy a következő postacímre: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanyolország.<br>
				Mindkét esetben azonosítania kell magát vezeték- és vezetéknevével, valamint szükség esetén be kell mutatnia a DNI- vagy nemzeti személyi igazolványának másolatát.<br>
				Abban az esetben, ha Ön meghatározott célból adta beleegyezését, joga van a hozzájárulását bármikor visszavonni, 
				anélkül, hogy az a visszavonás előtti hozzájáruláson alapuló kezelés jogszerűségét befolyásolná.<br>
				Ezenkívül, ha úgy gondolja, hogy probléma van azzal, ahogyan a Remove Background kezeli az Ön adatait, 
				panaszait a megfelelő <a href="{knowYourRightsLink}">adatvédelmi hatósághoz</a> fordulhat, amely a <a href="{aepdLink}">Spanyol Adatvédelmi Ügynökség</a> 
				a Spanyolország esetében jelzett.</p>


			<h3>4. Életkor</h3>
			<p>Az online szolgáltatás használatával kapcsolatban Ön kijelenti, hogy nagykorú, és rendelkezik a szükséges jogi 
				kötelezettséget vállal arra, hogy magára nézve kötelezőnek ismeri el ezt a megállapodást, és az oldalt annak feltételeinek megfelelően használja, amelyet Ön teljes mértékben 
				megérteni és elismerni.<br>
				Ön kijelenti, hogy a Szolgáltatás igénybevétele előtt és alatt a Szolgáltatás eléréséhez megadott összes információ a valóságnak megfelelő, teljes 
				és pontos.</p>


			<h3>5. Adathasználat</h3>
			<p>A Háttér eltávolítása az összegyűjtött adatokat a következőkre használja fel:</p>
			<ul>
				<li>A Szolgáltatás kezelése és frissítése (a jogalap a Szolgáltatás fenntartásához és fenntartásához fűződő jogos érdekünk 
					naprakész és jó állapotban).</li>
				<li>Foglalkozzon az Ön által feltett kérdésekkel (a jogalap a kérések teljesítéséhez fűződő jogos érdekünk, és 
					felhasználóink kétségei).</li>
				<li>Feldolgozza az Ön által teljesített kifizetéseket (a szerződés a jogalap).</li>
				<li>A szerződött szolgáltatás nyújtása (a szerződés a jogalap).</li>
				<li>Fenntartja a Szolgáltatás biztonságát, kivizsgálja az illegális tevékenységeket, betartatja szerződési feltételeinket és
					segítse az állambiztonsági erőket esetleges nyomozásaik keretében (a mi jogalapunk 
					jogos érdeke a Szolgáltatás és felhasználói biztonságának garantálásához és fenntartásához).</li>
			</ul>
			<p>A Háttér eltávolítása nem használ automatizált döntéseket, bár alapvető felhasználói profilokat hozhat létre, 
				jogi alapja a kereskedelmi célú jogos érdekünk és személyre szabott ajánlatok nyújtása.<br>
				Ezenkívül a Háttér eltávolítása felhasználhatja a felhasználói információkat összesített és névtelen adatok formájában, hogy megjelenítse azokat harmadik feleknek. 
				A felhasználókról és a Szolgáltatás használatáról statisztikákat és demográfiai információkat is megoszthat harmadik felekkel. 
				De ezek egyike sem teszi lehetővé, hogy a harmadik felek személyesen azonosítsák Önt.</p>

			<h5>5.1. E-mailekben és kapcsolatfelvételi űrlapokon</h5>
			<p>A webhely SSL-titkosítással rendelkezik, amely lehetővé teszi a felhasználó számára, hogy biztonságosan küldje el személyes adatait szabványos kapcsolatfelvételi űrlapokon.<br>
				Az összegyűjtött személyes adatokat automatizáltan kezeljük, és beépítjük a megfelelő fájlokhoz 
				a feldolgozási tevékenységek rekordját, és amelynek a Háttér eltávolítása a tulajdonosa.</p>
			<p>Ebben az értelemben:</p>
			<ul>
				<li>Megkapjuk az Ön IP-címét, amelyet az üzenet eredetének ellenőrzésére használunk, hogy megfelelő 
					ajánlásokat (például az információkat a megfelelő nyelven mutassa be), és feltárja az esetleges szabálytalanságokat 
					(például a Szolgáltatás kibertámadásának lehetséges kísérletei), valamint az Ön internetszolgáltatójával kapcsolatos adatok.</li>
				<li>Hasonlóan megadhatja nekünk adatait telefonon, e-mailben és más megjelölt kommunikációs eszközökön keresztül.</li>
			</ul>
			<p>A használt fizetési móddal kapcsolatban:</p>
			<ul>
				<li>A szolgáltatásainkért fizetendő fizetési szolgáltatóink hitel- vagy betéti kártyával fizetnek. 
					A Szolgálat vagy munkatársai soha nem férhetnek hozzá a banki adatokhoz (például a hitelkártyaszámhoz) 
					amelyet a felhasználó mint ügyfél biztosít azoknak a harmadik feleknek.</li>
			</ul>


			<h3>6. Adatmegőrzés</h3>
			<p>Az alábbiakban feltüntetik, hogy a Szolgáltatás által feldolgozott adatokat mennyi ideig tárolják:</p>
			<ul>
				<li>A bontott adatok törlési időszak nélkül megőrződnek.</li>
				<li>
					Az ügyféladatokat a minimálisan szükséges ideig tároljuk, és addig őrizhetjük meg:
					<ul>
						<li>5 év, a cikk szerint. 1964. évi Ptk. (személyes cselekmények külön határidő nélkül).</li>
						<li>6 év, a cikk szerint. 30. § (például könyvelési könyvek vagy számlák).</li>
					</ul>
				</li>
				<li>A felhasználói adatokat legfeljebb 12 hónapig őrizzük meg, hogy teljesíteni tudják kéréseiket.</li>
			</ul>


			<h3>7. Harmadik felekkel megosztott adatok</h3>
			<p>A Szolgáltatás egy részét harmadik felek kezelik.<br>
				A Háttér eltávolítása megköveteli, hogy a sajátjukon túlmenően megfeleljenek a jelen Adatvédelmi szabályzatnak. A Háttér eltávolítása azonban nem vállal felelősséget az irányelv betartásáért.<br>
				Bizonyos körülmények között a Háttér eltávolítása megoszthatja, felhasználhatja vagy megőrizheti harmadik felekkel az összegyűjtött személyes adatokat:</p>
			<ul>
				<li>A Szolgáltatás nyújtása:</li>
			</ul>
			<p>Azok a szolgáltatók, amelyek a nevünkben feladatokat látnak el, például fizetési szolgáltatásokat, webtárhelyet, üzleti elemzést, ügyfélszolgálatot vagy webes marketinget. Ezek a szolgáltatók összegyűjthetik és hozzáférhetnek a feladataik ellátásához szükséges információkhoz, de nem oszthatják meg vagy használhatják fel az információkat semmilyen más célra.</p>
			<ul>
				<li>Az illetékes hatóságokkal való együttműködés:</li>
			</ul>
			<p>Ha úgy gondoljuk, hogy ésszerűen szükséges bármely törvény, jogi eljárás vagy jogos érdek kielégítése. Mindenesetre csak a feltétlenül szükséges információkat adjuk meg.</p>


			<h3>8. Biztonsági intézkedések</h3>
			<p>A Háttér eltávolítása minden szükséges technikai és szervezési intézkedést elfogad
				az összegyűjtött személyes és nem személyes adatok biztonságának és integritásának védelme. 
				Mind a jogosulatlan hozzáférés, mind pedig a véletlen megváltoztatása, elvesztése vagy megsemmisülése ellen.<br>
				A Háttér eltávolítása semmilyen esetben sem tudja garantálni az összegyűjtött információk abszolút biztonságát, 
				ezért mindig együtt kell működnie, és a józan eszét kell használnia a megosztott információkkal kapcsolatban.<br>
				Ön tudomásul veszi és tudomásul veszi, hogy a törlés után is előfordulhatnak személyes és nem személyes adatok 
				látható marad a gyorsítótárban, vagy ha más felhasználók másolták vagy tárolták.</p>


			<h3>9. Az adatvédelmi szabályzat változásai</h3>
			<p>A jövőben frissíthetjük ezt az adatvédelmi szabályzatot. Változásairól a megadott e-mail címre küldött értesítéssel és/vagy weboldalunk jól látható helyen történő elhelyezésével értesítjük.</p>


			<h3>10. Kapcsolatfelvétel</h3>
			<p>Ha kérdése van ezzel az adatvédelmi irányelvvel kapcsolatban, forduljon hozzánk a következő címen:</p>
			<p>E-mail: {supportLink}<br> 
				Cím: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanyolország.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Utolsó frissítés: 2024. június 10',
		content: `
			<h3>1. Ki a felelős, és hogyan lehet kapcsolatba lépni velük?</h3>
			<p>A webhely kezelője a Remove Background S.L. címe: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanyolország.</p>
			<p>E-mailben veheti fel vele a kapcsolatot a következő címen: {supportLink}.</p>

			<h3>2. Milyen adatokat gyűjtenek?</h3>
			<p>
				Az Ön eszközére feltöltött cookie-kon keresztül automatikusan adatokat gyűjtünk, beleértve az elemzéseket is. 
				Ezenkívül összegyűjtjük az IP-címet, amelyről a kapcsolat létrejön, a használt eszköz típusát és jellemzőit, 
				az operációs rendszer verziója, a böngésző típusa, nyelve, dátuma, országa, időpontja, 
				többek között az URL, ahonnan érkezett, az URL, ahová eljut, vagy a használt mobilhálózat.<br>
				A felhasználó önként ad nekünk bizonyos információkat, például vezeték- és vezetéknevét, e-mail címét vagy banki adatait 
				hogy kapcsolatba léphessen velünk, regisztráljon a szolgáltatásra vagy vásároljon előfizetést.
			</p>

			<h3>3. Mire használják az összegyűjtött adatokat?</h3>
			<p>
				A Szolgáltatás az összegyűjtött adatokat többek között a szolgáltatás adminisztrálására, frissítésére, az Ön kéréseinek megválaszolására használja fel, 
				hírlevelünket és promóciós ajánlatainkat e-mailben elküldjük, regisztrációját a platformon kezeljük, kezeljük és biztosítjuk 
				az előfizetéséhez kapcsolódó szolgáltatásokat, feldolgozza az Ön által teljesített befizetéseket és kiállítja a megfelelő számlákat, 
				fenntartani a Szolgáltatás biztonságát, kivizsgálni a jogellenes tevékenységeket, betartatni feltételeinket és 
				segíti az állambiztonsági erőket és szerveket esetleges nyomozásaik során.
			</p>

			<h3>4. Mennyi ideig tárolják őket?</h3>
			<ul>
				<li>A bontott adatok törlési időszak nélkül megőrződnek.</li>
				<li>
					Az ügyféladatokat a minimálisan szükséges ideig tároljuk, és addig őrizhetjük meg:
					<ul>
						<li>5 év, a cikk szerint. 1964. évi Ptk. (személyes cselekmények külön határidő nélkül).</li>
						<li>6 év, a cikk szerint. 30. § (például számviteli könyv vagy számla).</li>
					</ul>
				</li>
				<li>A felhasználók adatait legfeljebb 12 hónapig őrizzük meg annak érdekében, hogy teljesítsük kéréseiket.</li>
				<li>A Szolgáltatás által a közösségi hálózatok oldalaira és profiljaira feltöltött felhasználói adatokat a felhasználó hozzájárulásának felajánlásától visszavonásig megőrizzük.</li>
			</ul>

			<h3>5. Milyen jogokkal rendelkezik felhasználóként?</h3>

			<p>
				Hozzáférés joga: Az érintett jogosult arra, hogy az adatkezelőtől visszaigazolást kérjen arról, hogy 
				vagy nem kezelnek rá vonatkozó személyes adatokat.
			</p>
			<p>
				Helyesbítés joga: az érintett jogosult arra, hogy indokolatlan késedelem nélkül kérje az adatkezelőtől 
				pontatlan és őt közvetlenül érintő személyes adatok helyesbítését. Hasonlóképpen az érdekelt fél 
				jogosult a hiányos személyes adatok kiegészítésére, beleértve a kiegészítő nyilatkozatot is.
			</p>
			<p>
				Törlési jog: Az érintett jogosult arra, hogy indokolatlan késedelem nélkül kérje az adatkezelőtől a törlést. 
				az őt érintő személyes adatokról.
			</p>
			<p>
				Az adatkezelés korlátozásához való jog: abban áll, hogy a felelős személy korlátozza adatai kezelését, 
				bár gyakorlatának két szempontja van: 1) Amikor megkérdőjelezi személyes adatai pontosságát, egy olyan időszakban, amely lehetővé teszi 
				az ellenőrzésért felelős személy és 2) Ha Ön tiltakozott személyes adatainak kezelése ellen, hogy a felelős személy 
				jogos érdek vagy közérdekű küldetés alapján végzi, miközben az illetékes ellenőrzi, hogy ezek az okok-e 
				érvényesül a tiéd felett.
			</p>
			<p>
				Adathordozhatósághoz való jog: Az érintett jogosult az őt érintő személyes adatok megismeréséhez, 
				amelyet strukturált formában, közös használatú és mechanikus leolvasású adatkezelő rendelkezésére bocsátott, és 
				továbbítani azokat egy másik adatkezelőnek anélkül, hogy az adatkezelő akadályozná.
			</p>
			<p>
				Ebben az értelemben az érdekelt fél jogosult arra, hogy személyes adatait közvetlenül az adatkezelőtől továbbítsa 
				a vezérlőhöz, ha ez műszakilag lehetséges.
			</p>

			<h3>6. Hogyan gyakorolhatja jogait?</h3>

			<p>
				Személyes adatokkal kapcsolatos jogait bármikor gyakorolhatja, ha e-mailt küld a következő címre: {supportLink} vagy a következő postacímre: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanyolország. Mindkét esetben a vezeték- és vezetéknevével kell azonosítania magát, 
				valamint szükség esetén a DNI vagy a nemzeti azonosító másolatát.<br>
				Ezen túlmenően, ha úgy gondolja, hogy probléma van azzal, ahogyan a Remove Background kezeli adatait, irányíthatja követeléseit 
				a megfelelő <a href="{knowYourRightsLink}">adatvédelmi hatóságnak</a>, amely a <a href="{aepdLink}">Spanyol Adatvédelmi Ügynökség</a> 
				a Spanyolország esetében jelzett.
			</p>

			<h3>7. Bevezettek-e biztonsági intézkedéseket?</h3>
			<p>
				A Szolgáltató minden szükséges technikai és szervezési intézkedést megtesz a személyek biztonságának és integritásának védelme érdekében 
				és az összegyűjtött nem személyes adatok. Mind a jogosulatlan hozzáférés, mind a véletlen megváltoztatás, elvesztés vagy megsemmisülés ellen.<br>
				Mindenesetre a Szolgáltatás nem tudja garantálni az összegyűjtött információk abszolút biztonságát, ezért Önnek együtt kell működnie és 
				mindig használja a józan eszét a megosztott információkkal kapcsolatban.<br>
				Ön tudomásul veszi és tudomásul veszi, hogy a személyes és nem személyes adatok a törlés után is megtekinthetők a gyorsítótárban vagy 
				ha más felhasználók másolják vagy tárolják.
			</p>

			<h3>8. Vannak személyes adatok vagy nemzetközi továbbítások?</h3>

			<p>
				Nem továbbítunk adatot vagy nemzetközi átvitelt. Vannak azonban harmadik felek, amelyek a Szolgáltatás egy részét kezelik 
				megköveteljük az adatvédelmi szabályzatunk betartását, amennyiben az rájuk vonatkozik, és megvan a sajátjuk. 
				Ezek a harmadik felek olyan szolgáltatók, amelyek a nevünkben olyan funkciókat látnak el, mint a webtárhely, 
				analitikai megfigyelés vagy webfejlesztés.<br>
				Akkor is, ha úgy gondoljuk, hogy ez ésszerűen szükséges bármely törvény, jogi eljárás vagy jogos érdek kielégítéséhez. 
				Mindenesetre csak a szigorúan előírt információkat adjuk meg.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Utolsó frissítés: 2024. június 21',
		content: `
			<h3>Összefoglalás</h3>
			<ul>
			    <li>Használt cookie-k: <strong>saját és harmadik felek</strong></li>
			    <li>Statisztikák készítésére használják? <strong>Igen, a szolgáltatás jobb kezeléséhez fűződő jogos érdekünk alapján.</strong></li>
			    <li>A webhelyen keresztül cookie-kat telepítő harmadik féltől származó szolgáltatások: <strong>Google, Google Analytics, Cloudflare és Stripe.</strong></li>
			</ul>

			<h3>A cookie-k konfigurálása és letiltása</h3>
			<p>
			    Engedélyezheti, blokkolhatja vagy törölheti a készülékére telepített sütiket a böngészőből. Ha nem engedélyezi a cookie-k telepítését az eszközére, 
			    a böngészési élmény ronthat. Az alábbiakban megtudhatja, hogyan konfigurálhatja a cookie-kat az egyes böngészőkben:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Típusok és felhasználások</h3>
			<p>A szolgáltatás saját és harmadik féltől származó cookie-kat használ a böngészés javítása, a szolgáltatás nyújtása és a webhely használatára vonatkozó statisztikák beszerzése érdekében.</p>

			<h3>2. Mi az a cookie, és mire használják?</h3>
			<p>
			    A cookie egy szöveges fájl, amelyet a számítógép, a mobil vagy a táblagép webböngészőjébe küldenek, és információkat tárolnak és kérnek le
			    a böngészés kész. Például, hogy megjegyezze felhasználónevét és jelszavát vagy profilbeállításait.
			</p>

			<h3>3. Milyen típusú cookie-k léteznek?</h3>
			<p>Attól függően, hogy ki kezeli őket:</p>
			<ul>
			    <li>Saját cookie-k; saját berendezésünkről vagy webdomainünkről érkeznek a böngészőjébe.</li>
			    <li>Harmadik féltől származó cookie-k; azokat olyan berendezésekről vagy webdomainekről küldik a böngészőjébe, amelyeket nem közvetlenül mi kezelünk, hanem egy harmadik fél, például a Google.</li>
			</ul>
			<p>Attól függően, hogy mennyi ideig maradnak aktívak, a következők vannak:</p>
			<ul>
			    <li>Munkamenet cookie-k; mindaddig a böngésző cookie-fájljában maradnak, amíg el nem hagyja a webhelyet, így egyik sem marad az eszközén.</li>
			    <li>Állandó cookie-k; az Ön készülékén maradnak, és weboldalunk minden alkalommal elolvassa őket, amikor új látogatást tesz. Ezek a cookie-k egy adott dátum után leállnak.</li>
			</ul>
			<p>Végül a célnak megfelelően a következőket kínáljuk:</p>
			<ul>
			    <li>Technikai cookie-k; javítják a böngészést és a webhely megfelelő működését.</li>
			    <li>Személyre szabó cookie-k; egy sor kritérium alapján előre meghatározott jellemzőkkel teszik lehetővé a szolgáltatáshoz való hozzáférést.</li>
			    <li>Analytics cookie-k; lehetővé teszik a nyújtott szolgáltatás igénybevételének mérését és statisztikai elemzését.</li>
			</ul>
			<p>A <strong>remove-background.com</strong></p> által használt harmadik féltől származó cookie-k listája
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Cookie-ik (NID vagy CONSENT) lehetővé teszik a hirdetések Google-on kívüli megjelenésének személyre szabását vagy információk tárolását
			        például az előnyben részesített nyelv a keresési eredmények megjelenítésekor.<br><a href="{externalLink: googleCookieTypes}">További információ</a> a Google által a különféle szolgáltatásaiban használt cookie-k típusairól.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Cookie-ik (például _ga) lehetővé teszik annak megszámlálását, hogy a felhasználó hányszor látogat meg egy webhelyet, hogyan, mikor és honnan.<br>
			        Mindenesetre <a href="{externalLink: disableGoogleAnalytics}">itt</a> letilthatja a Google Analytics cookie-kat.
			    </li>
			    <li>Cloudflare: Ha többet szeretne megtudni a Cloudflare cookie-szabályzatáról és használatáról, kattintson <a href="{externalLink: cloudflareCookiesPolicy}">erre a linkre</a>.</li>
			    <li>Stripe: <a href="{externalLink: stripeCookiesPolicy}">itt</a> talál információkat a Stripe cookie-kra vonatkozó szabályzatáról és használatáról.</li>
			</ul>
		`
	}
};
